import * as React from 'react';
import {MouseEvent} from 'react';
import Header from '../../components/header';
import { Container, Row, Col, ButtonToolbar, Button, Spinner } from 'react-bootstrap';
import Learning, { ScenarioItem, ScenarioItemType, Hint, Answer, Result, Question as ScenarioQuestion } from '../../services/Learning'
import Courses, { Course } from '../../services/CoursesService';
import Question from './Question';
import HintComponent from './Hint';
import ResultComponent from './ResultComponent';
import { Redirect } from 'react-router';
import { AppRoute } from '../../definitions/routes';

class Progress extends React.Component {
  render() {
    return (
      <div>
        <Spinner animation="border" />
      </div>
    );
  }
}

export interface ICasesProps {
    assignmentId: Number
}

export interface ICasesState {
    scenarioItem?: ScenarioItem,
    courseName: string,
    title: string,
    hasNextQuestion: boolean,
    hasPreviousQuestion: boolean,
    selectedAnswers: (Answer | null)[],
    optionalAnswers: string[],
    redirectToCourses: boolean,
    actionInPropgress: boolean  // for reset selected answers on step change (in Question component),
    learningHistory: ScenarioQuestion[]
}

export default class Cases extends React.Component<ICasesProps, ICasesState> {
  
  
  constructor(props: ICasesProps) {
    super(props);

    this.state = {
        scenarioItem: undefined,
        courseName: '',
        title: '',
        hasNextQuestion: true, //Не нужен навереное, можно отталкиваться от текущего типа
        hasPreviousQuestion: true,
        selectedAnswers: [],
        optionalAnswers: [],
        redirectToCourses: false,
        actionInPropgress: true,
        learningHistory: []
    }
  }

  componentDidMount = async () => {
    try {
      let scenarioItem = await Learning.getCurrentItem(this.props.assignmentId);
      const currentAssignment = await Courses.getAssignmentById(this.props.assignmentId as number);
      let learningHistory: ScenarioQuestion[] = [];
      if (scenarioItem.scenarioItemType == ScenarioItemType.RESULT) {
        learningHistory = await Learning.getLearningHistory(this.props.assignmentId as number);
      }
      
      this.setState({
        scenarioItem,
        courseName: `${currentAssignment.course.name}`,
        actionInPropgress: false,
        learningHistory
      });  
    } catch(err) {
      console.log(err);
      this.setState({
        actionInPropgress: false
      });
    }
  }

  onPreviousQuestion = ((event: MouseEvent) => {
    console.log(event);
  })

  onNextQuestion = async (event: MouseEvent) => {
    this.setState({actionInPropgress: true});
    try {
      if (!this.state.scenarioItem) {
        return;
      }

      if (this.state.scenarioItem.scenarioItemType == ScenarioItemType.RESULT) {
        this.setState({redirectToCourses: true});
        return;
      } if (this.state.scenarioItem.scenarioItemType == ScenarioItemType.QUESTION) {
        let naswerIds = this.state.selectedAnswers.filter(answer => answer).map(answer => answer ? answer.id : 0);
        await Learning.sendAnswers(this.props.assignmentId, naswerIds, this.state.optionalAnswers);
        this.setState({optionalAnswers: []});
      } else if (this.state.scenarioItem.scenarioItemType == ScenarioItemType.HINT) {
        await Learning.hintAccepted(this.props.assignmentId);
      }
      let scenarioItem = await Learning.getCurrentItem(this.props.assignmentId);
      let learningHistory: ScenarioQuestion[] = [];
      if (scenarioItem.scenarioItemType == ScenarioItemType.RESULT) {
        learningHistory = await Learning.getLearningHistory(this.props.assignmentId as number);
      }
      this.setState({
        scenarioItem,
        learningHistory
      });
    } catch(err) { }
    this.setState({actionInPropgress: false});
  }

  selectedAswersChanged = (selectedAnswers: (Answer | null)[]) => {    
    this.setState({selectedAnswers});    
  }

  optionalAnswersChanged = (optionalAnswers: string[]) => {
    this.setState({optionalAnswers: optionalAnswers.filter(a => a)});
  }

  public render() {

    const type = this.state.scenarioItem ? this.state.scenarioItem.scenarioItemType : null;
    //const course = this.state.scenarioItem && this.state.scenarioItem.scenarioItem
    return (
        this.state.redirectToCourses ? 
          <Redirect to={AppRoute.COURSES} />
        : 
          <div style={{display: "flex", flexDirection: "column", height: "100%"}}>
            <Header title={`Курс: ${this.state.courseName }`} />            
              {(this.state.scenarioItem && !this.state.actionInPropgress) ?
                <Container>
                    {this.state.scenarioItem.scenarioItemType == ScenarioItemType.QUESTION ?
                      <Question question={this.state.scenarioItem.scenarioItem as ScenarioQuestion} selectedAswersChanged={this.selectedAswersChanged} optionalAnswersChanged={this.optionalAnswersChanged}/>
                    :null}
                    {this.state.scenarioItem.scenarioItemType == ScenarioItemType.HINT ?
                      <HintComponent hint={this.state.scenarioItem.scenarioItem as Hint} />
                    :null} 
                    {this.state.scenarioItem.scenarioItemType == ScenarioItemType.RESULT ?
                      <ResultComponent result={this.state.scenarioItem.scenarioItem as Result} learningHistory={this.state.learningHistory} />
                    :null} 
                    <Row> 
                      <Col md={12} className='buttons-prev-next'>
                        <ButtonToolbar className='float-right'>
                            {/* <Button variant='outline-primary' onClick={this.onPreviousQuestion} disabled={this.state.hasPreviousQuestion}>Назад</Button> */}
                            <Button onClick={() => this.setState({redirectToCourses: true})} variant="link" >
                                <span>{'Перейти к выбору курса'}</span>
                            </Button>
                            {this.state.scenarioItem && this.state.scenarioItem.scenarioItemType != ScenarioItemType.RESULT ?
                              <Button onClick={this.onNextQuestion} 
                                disabled={this.state.scenarioItem && this.state.scenarioItem.scenarioItemType == ScenarioItemType.QUESTION 
                                  && this.state.selectedAnswers.filter(a => a).length == 0 
                                  && ((this.state.scenarioItem.scenarioItem as any).allowOptional && (this.state.optionalAnswers.length == 0 || this.state.optionalAnswers[0].trim().length == 0))}
                                >
                                  <span>Далее</span>
                              </Button>
                            : null}
                        </ButtonToolbar>
                      </Col>
                    </Row>
                </Container>              
            : this.state.actionInPropgress ? <div style={{height: "100%", display: "flex", alignItems: "center", justifyContent: "center"}}><Progress /></div> :
              <Container>
                <Row> 
                  <Col md={12} className='buttons-prev-next'>
                    <ButtonToolbar className='float-right'>
                        <Button onClick={() => this.setState({redirectToCourses: true})} variant="link" >
                            <span>{'Перейти к выбору курса'}</span>
                        </Button>
                    </ButtonToolbar>
                  </Col>
                </Row>
              </Container>
              }
          </div>
      );
  }
}

